import { render, staticRenderFns } from "./RemoteFolderConfigurationPage.vue?vue&type=template&id=e99a7dba&"
import script from "./RemoteFolderConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e99a7dba')) {
      api.createRecord('e99a7dba', component.options)
    } else {
      api.reload('e99a7dba', component.options)
    }
    module.hot.accept("./RemoteFolderConfigurationPage.vue?vue&type=template&id=e99a7dba&", function () {
      api.rerender('e99a7dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RemoteFolder/RemoteFolderConfigurationPage.vue"
export default component.exports